import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-breadcrumb/dist/index.module.css';
import Slash2 from '@dtsl/icons/dist/icons/react/Slash2';
function BreadcrumbItem(props) {
  const {
    breadcrumb,
    indexSelected,
    isLastItem,
    onSelect
  } = props;
  const {
    index,
    url = '#',
    label,
    disabled,
    target = '_self',
    className = ''
  } = breadcrumb;
  const breadcrumbItemClasses = classNames({
    [styles['sib-breadcrumb-item']]: true,
    [styles['sib-breadcrumb-item__selected']]: isLastItem,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("li", {
    className: styles['sib-breadcrumb-items'],
    disabled: disabled,
    key: index
  }, /*#__PURE__*/React.createElement("a", {
    href: url,
    rel: "noreferrer",
    target: target,
    disabled: disabled,
    onClick: event => onSelect(breadcrumb, index, event),
    className: breadcrumbItemClasses,
    "aria-current": indexSelected == index ? 'page' : isLastItem ? 'page' : null
  }, label), !isLastItem ? /*#__PURE__*/React.createElement(Slash2, {
    className: styles['sib-breadcrumb-item__separator']
  }) : '');
}
BreadcrumbItem.defaultProps = {
  onSelect: () => {},
  breadcrumbs: {},
  indexSelected: 0,
  index: 0,
  isLastItem: false
};
BreadcrumbItem.propTypes = {
  onSelect: PropTypes.func,
  breadcrumb: PropTypes.shape({
    url: PropTypes.string,
    target: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    index: PropTypes.number
  }),
  indexSelected: PropTypes.number,
  isLastItem: PropTypes.bool
};
export default BreadcrumbItem;